// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rht-dismiss-wrap {
  cursor: grab;
}

.rht-dismiss-wrap:active {
  cursor: grabbing;
}

.rht-dismiss-x {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0 4px 0 6px;
  padding: 0;
  border: none;
  border-radius: 8px;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.rht-dismiss-x:hover {
  color: #fff;
  background: rgba(0, 0, 0, 0.22);
}

.rht-dismiss-x:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.9);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ToastDismissibleBar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB","sourcesContent":[".rht-dismiss-wrap {\n  cursor: grab;\n}\n\n.rht-dismiss-wrap:active {\n  cursor: grabbing;\n}\n\n.rht-dismiss-x {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  margin: 0 4px 0 6px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  font-size: 20px;\n  line-height: 1;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  background: rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.rht-dismiss-x:hover {\n  color: #fff;\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.rht-dismiss-x:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.9);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
